import { useState } from 'react'

export default function PrefetchLink({
  href,
  children,
  isActive = false,
  className = '',
  enablePrefetch = true,
  ...props
}: {
  href: string
  children?: string
  isActive?: boolean
  className?: string
  enablePrefetch?: boolean
}) {
  const [isPrefetched, setIsPrefetched] = useState(false)

  const handlePrefetch = () => {
    // Don't prefetch if disabled, already prefetched, or is active link
    if (!enablePrefetch || isPrefetched || isActive) return

    const link = document.createElement('link')
    link.rel = 'prefetch'
    link.href = href
    document.head.appendChild(link)

    setIsPrefetched(true)
  }

  return (
    <a
      href={href}
      className={className}
      onMouseEnter={handlePrefetch}
      onTouchStart={handlePrefetch}
      onFocus={handlePrefetch}
      {...props}
    >
      {children}
    </a>
  )
}
